module.exports = __webpack_public_path__ + "836c7f82e653f6500dd0c16508f1b4ff.pdf";